var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16.907,
  height: 7.514,
  viewBox: "0 0 16.907 7.514"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.1,140.555l3.757-3.425a.314.314,0,0,1,.342-.049.284.284,0,0,1,.186.284v2.192H16.594a.3.3,0,0,1,.313.313v1.879a.3.3,0,0,1-.313.313H4.383v2.192a.3.3,0,0,1-.186.284.305.305,0,0,1-.343-.059L.1,141.014a.32.32,0,0,1-.1-.235A.309.309,0,0,1,.1,140.555Z",
  transform: "translate(0 -137.052)",
  fill: "#fff"
})));
export default __webpack_public_path__ + "static/media/long-arrow-pointing-to-the-right.e7775b9d.svg";
export { SvgComponent as ReactComponent };